<template>
  <div>
    <div v-if="label" class="text-sm font-semibold text-secondary-800 pb-2">{{ label }}</div>
    <!-- plan §7 rule 2: exactly one department -> static text, not a disabled dropdown -->
    <div v-if="options.length === 1" class="text-sm text-gray-800 py-1">
      {{ options[0].name }}
      <span class="text-xs text-gray-500 ml-1">{{ $t("securone.department.only_one") }}</span>
    </div>
    <div v-else-if="options.length" class="border border-secondary-200 rounded divide-y divide-secondary-100" :class="{ 'overflow-y-auto': options.length > 8 }" :style="options.length > 8 ? 'max-height: 260px' : ''">
      <label v-for="d in options" :key="d._id" class="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-50" :class="{ 'bg-secondary-50': selected.includes(String(d._id)) }">
        <input :type="single ? 'radio' : 'checkbox'" class="h-4 w-4" :class="single ? 'form-radio' : 'form-checkbox'" :value="String(d._id)" :checked="selected.includes(String(d._id))" @change="toggle(String(d._id))" />
        <span class="text-sm text-gray-800">{{ d.name }}</span>
      </label>
    </div>
    <div v-else class="text-sm text-gray-400 py-1">{{ $t("securone.department.none_available") }}</div>
    <div v-if="help" class="text-xs text-gray-500 mt-1">{{ help }}</div>
    <div v-if="required && !selected.length && touched" class="text-xs text-red-600 mt-1">{{ $t("securone.department.required") }}</div>
  </div>
</template>

<script>
// Department picker (spec §9): free choice for a customer user and Securdia
// staff, limited to own departments for a department user (the store's
// `departments` already is that list), prefilled as static text when there is
// exactly one. v-model is an array of department ids.
export default {
  name: "DepartmentPicker",
  props: {
    value: { type: Array, default: () => [] },
    label: { type: String, default: "" },
    help: { type: String, default: "" },
    single: { type: Boolean, default: false },
    required: { type: Boolean, default: true },
    // override the store's list (e.g. a subset the object may be scoped to)
    departments: { type: Array, default: null },
  },
  data() {
    return { touched: false };
  },
  computed: {
    options() {
      return this.departments || this.$store.getters["securone/departments"];
    },
    selected() {
      return (this.value || []).map(String);
    },
  },
  methods: {
    toggle(id) {
      this.touched = true;
      if (this.single) return this.$emit("input", [id]);
      const next = this.selected.includes(id) ? this.selected.filter((x) => x !== id) : [...this.selected, id];
      this.$emit("input", next);
    },
    // auto-select the only department, so the form is valid without a click
    prefill() {
      if (this.options.length === 1 && !this.selected.length) this.$emit("input", [String(this.options[0]._id)]);
    },
  },
  watch: {
    options: {
      immediate: true,
      handler() {
        this.prefill();
      },
    },
  },
};
</script>
